/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingSeverityResponse {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingSeverityResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingSeverityResponse>): AwsSecurityHubFindingSeverityResponse {
        let obj = Object.assign(new AwsSecurityHubFindingSeverityResponse(), model);
        AwsSecurityHubFindingSeverityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingSeverityResponse>): AwsSecurityHubFindingSeverityResponse {
        if (!model) return null;
        return AwsSecurityHubFindingSeverityResponse.newInstance(<AwsSecurityHubFindingSeverityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingSeverityResponse) {
        if (!obj) return;

        models.AwsSecurityHubFindingSeverityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingSeverityResponse): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingSeverityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Severities
     */
    severities: Array<string>;

}
